module.exports = __webpack_public_path__ + "img/rat.b01d4d3e.svg";